var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6783 4.2652C21.0841 4.63981 21.1094 5.27246 20.7348 5.67829L15.3179 11.5466L20.7809 18.3753C21.1259 18.8066 21.056 19.4359 20.6247 19.7809C20.1934 20.1259 19.5641 20.056 19.2191 19.6247L13.2191 12.1247C12.9103 11.7387 12.9299 11.185 13.2652 10.8217L19.2652 4.32172C19.6398 3.9159 20.2725 3.8906 20.6783 4.2652Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6783 4.2652C11.0841 4.63981 11.1094 5.27246 10.7348 5.67829L5.3179 11.5466L10.7809 18.3753C11.1259 18.8066 11.056 19.4359 10.6247 19.7809C10.1934 20.1259 9.56414 20.056 9.21913 19.6247L3.21913 12.1247C2.91033 11.7387 2.9299 11.185 3.2652 10.8217L9.2652 4.32172C9.6398 3.9159 10.2725 3.8906 10.6783 4.2652Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFold);
export default __webpack_public_path__ + "static/media/Icon_Fold.9db3dcb8ef2640e0368f3f13a165dcff.svg";
export { ForwardRef as ReactComponent };